import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {VoucherQuantityLimitExceededIcon} from 'assets/icons/voucherQuantityLimitExceededIcon';
import Button from 'components/button/Button';
import {useAppDispatch, useAppSelector} from 'hooks';
import {removePromotionVoucherAction, updatePreviewItemQuantityAction} from 'store/actions/basket-action';

export type VoucherQuantityLimitExceededAlertContentProps = {
  onClose: () => void;
};

const maxQuantity = 1; // right now the max quantity for omni voucher is 1

export const VoucherQuantityLimitExceededAlertContent = (props: VoucherQuantityLimitExceededAlertContentProps) => {
  const {onClose} = props;
  const {t} = useTranslation();
  const dispatch = useAppDispatch();
  const basket = useAppSelector((state) => state.basket.basket);
  const idToken = useAppSelector((state) => state?.auth?.idToken);
  const {productName} = useAppSelector((state) => state.alert.details);

  const adjust = () => {
    const promotionSku = basket?.appliedVoucherPromotion?.[0].skus[0];
    const item = basket?.basketItems.find((item) => item.productDetails.sku === promotionSku);
    dispatch(
      updatePreviewItemQuantityAction({
        productId: item?.productId,
        quantity: maxQuantity,
        variantId: item?.variantId,
        idToken
      })
    );
    onClose();
  };

  const continueWithout = () => {
    dispatch(removePromotionVoucherAction({}));
    onClose();
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box alignItems="center" width="100%" display="flex" flexDirection="column" gap={1} mb={2}>
        <VoucherQuantityLimitExceededIcon />
        <Typography fontSize={20} fontWeight={700} align="center">
          {t('alerts.voucherQuantityLimitExceeded.title', {productName})}
        </Typography>
        <Box display="flex" alignItems="center" flexDirection="column">
          <Typography fontSize={16} align="center">
            {t('alerts.voucherQuantityLimitExceeded.description1', {maxQuantity})}
          </Typography>
          <Typography fontSize={16}>{t('alerts.voucherQuantityLimitExceeded.description2', {maxQuantity})}</Typography>
        </Box>
      </Box>
      <Button onClick={adjust} shape="rounded" variant="contained">
        {t('alerts.voucherQuantityLimitExceeded.adjust', {maxQuantity})}
      </Button>
      <Button onClick={continueWithout} shape="rounded" variant="outlined">
        {t('alerts.voucherQuantityLimitExceeded.continueWithout')}
      </Button>
    </Box>
  );
};
